import { useEffect, useRef } from 'react';
import useWorldStore from './store/worldStore';
import WorldScene from './components/WorldScene';
import GlobeView from './components/GlobeView';
import { loadPersistedScenes, generateScene } from './services/sceneService';

function App() {
  const activeView = useWorldStore((s) => s.activeView);
  const agents = useWorldStore((s) => s.agents);
  const prevView = useRef(activeView);
  const lifeSceneKey = agents
    .map((agent) => `${agent.id}:${agent.mode || ''}:${agent.activity || ''}:${agent.locationTag || ''}`)
    .join('|');

  // Map→Agent view continuity: carry selection across
  useEffect(() => {
    if (prevView.current === 'world' && activeView === 'agent') {
      const zoomTarget = useWorldStore.getState().mapZoomTarget;
      if (zoomTarget) {
        useWorldStore.getState().selectAgent(zoomTarget);
        useWorldStore.getState().setMapZoomTarget(null);
      }
    }
    prevView.current = activeView;
  }, [activeView]);

  // Load persisted scenes from localStorage
  useEffect(() => { loadPersistedScenes(); }, []);

  // Scene pre-generation for agents in life activities
  useEffect(() => {
    const currentAgents = useWorldStore.getState().agents;
    for (const agent of currentAgents) {
      if (agent.mode === 'life' && agent.activity && agent.locationTag) {
        generateScene(agent.activity, agent.locationTag);
      }
    }
  }, [lifeSceneKey]);

  return (
    <div data-ego-world-viewport style={{ position: 'relative', width: '100%', height: '100%' }}>
      {activeView === 'world' ? <GlobeView /> : <WorldScene />}
    </div>
  );
}

export default App;
